module.exports = __webpack_public_path__ + "static/media/routes05.d25aa9e4.webp";